import { useMutation } from "@apollo/client";
import { gql } from "./types";

const ENABLE_MFA = gql(/* GraphQL */ `
  mutation EnableMfa($code: String!) {
    enableMfa(code: $code) {
      id
    }
  }
`);

const DISABLE_MFA = gql(/* GraphQL */ `
  mutation DisableMfa($code: String!) {
    disableMfa(code: $code) {
      id
    }
  }
`);

export const useMfaToggle = (refetchQueries: string[] = []) => {
  const [enableMfa, enableResult] = useMutation(ENABLE_MFA, {
    refetchQueries,
  });

  const [disableMfa, disableResult] = useMutation(DISABLE_MFA, {
    refetchQueries,
  });

  const enable = async (code: string) => {
    const { data } = await enableMfa({ variables: { code } });
    return data?.enableMfa?.id;
  };

  const disable = async (code: string) => {
    const { data } = await disableMfa({ variables: { code } });
    return data?.disableMfa?.id;
  };

  return {
    enable,
    disable,
    enableLoading: enableResult.loading,
    disableLoading: disableResult.loading,
    enableError: enableResult.error,
    disableError: disableResult.error,
  };
};
